<template>
  <label
    class="pill"
    :type="type">
    <span
      class="icon-before">
      <slot></slot>
    </span>
    <span>{{ btnText }}</span>
    <span class="icon-after">
      <slot
        name="icon-after">
      </slot>
    </span>
      <input
        type="file"
        @change="click($event)"
        :accept="accept"/>
  </label>
</template>

<script>
export default {
  // props: ['btnText', 'id'],
  props: {
    btnText: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'button'
    },
    accept: {
      type: String,
      default: '*'
    }
  },
  methods: {
    click: function (event) {
      this.$emit('change', event);
      this.resetInputs();
    },
    resetInputs () {
      const inputs = document.getElementsByTagName('input');
      for (let i = 0; i < inputs.length; i++) {
        const input = inputs[i];
        input.value = '';

        if (!/safari/i.test(navigator.userAgent)) {
          input.type = '';
          input.type = 'file';
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../stylesheets/variables.scss";

$btn-padding: $sp-margin;

.pill {
  background: $primary;
  border-radius: 2em;
  border: 0;
  color: $white;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-left: $btn-padding;
  padding-right: $btn-padding;
  transition: background 0.3s;
  cursor: pointer;
  > * {
    margin-top: 2px;
  }

  &:hover {
    background: $primary-dark2;
  }
  &:focus {
    outline: $link-dark solid 3px;
    outline-offset: 2px;
  }
  &:active,
  &:active:focus {
    background: $primary-dark3;
    outline: 0;
  }
  &[disabled] {
    opacity: 0.25;
    pointer-events: none;
  }

  &[btn-size="xs"] {
    font-size: $fs-xs;
    min-height: $height1;
    padding-left: $btn-padding * 0.5;
    padding-right: $btn-padding * 0.5;
  }
  &[btn-size="s"] {
    font-size: $fs-s;
    min-height: $height2;
  }
  &[btn-size="m"] {
    font-size: $fs;
    min-height: $height3;
  }
  &[btn-size="l"] {
    font-size: $fs-xl;
    min-height: $height5;
    padding-left: $btn-padding * 1.5;
    padding-right: $btn-padding * 1.5;
  }

  &[btn-type="secondary"] {
    background-color: transparent;
    border: 1px solid $black-trans6;
    color: $black-trans2;
    transition-property: color;
    &:hover {
      color: $black-trans6;
    }
    &:active {
      background-color: transparent;
      color: $black-trans2;
      border-color: $black-trans2;
    }
  }
  &[btn-inverse]:not([controlsBg="light"]) {
    border-color: $white-trans2;
    color: $white-trans2;
    transition-property: color border;
    &:hover {
      border: 1px solid $white-trans6;
      color: $white-trans6;
    }
  }

  &.pressed.pressed {
    background-color: $active;
    border-color: $active;
    color: $white;
    outline: 0;
    &:hover {
      color: $white;
    }
  }

  .icon-before > svg {
    margin-right: $sp-margin-smaller;
  }
  .icon-after > svg {
    margin-left: $sp-margin-small;
  }

  input[type="file"] {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/buttons/BtnInputFile.vue